import { FC } from 'react';

type Props = {
  onConfirm: () => void;
  onDismiss: () => void;
};

const CfdAddOnModal: FC<Props> = ({ onConfirm, onDismiss }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl w-full max-w-sm mx-4 px-6 pt-8 pb-8 flex flex-col">
        <h2 className="text-2xl font-bold text-content-primary mb-3">Are you looking to trade CFDs and options?</h2>

        <p className="text-sm text-content-secondary mb-8">
          You can add CFDs and options to your account. Add these products at any time within the platform.
        </p>

        <button
          type="button"
          onClick={onConfirm}
          className="w-full py-4 px-4 bg-[#3B5BDB] hover:bg-[#2F4BC4] active:bg-[#2439A8] cursor-pointer transition-colors !text-white rounded-full font-medium mb-4 text-base"
        >
          Yes find out more
        </button>

        <button
          type="button"
          onClick={onDismiss}
          className="w-full py-4 px-4 bg-white border border-[#3B5BDB] hover:bg-azure-10 active:bg-azure-20 cursor-pointer transition-colors text-content-primary rounded-full font-medium text-base"
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default CfdAddOnModal;
